import create from 'zustand';

const usePlayModeState = create(set => ({
  // current node results
  nodeResults: null,
  setNodeResults: val => set({ nodeResults: val }),
  // animation timing
  nodesAnimated: [],
  addToNodesAnimated: val =>
    set(state => ({ nodesAnimated: [...state.nodesAnimated].concat([val]) })),
  resetNodesAnimated: () => {
    set({ nodesAnimated: [] });
  },
  // reset all state
  resetState: () => {
    set({
      nodeResults: null,
      nodesAnimated: [],
    });
  },
}));

export { usePlayModeState };
